/**
 * Uses Swiper package to create a carousel for product media
 * More info: https://swiperjs.com/
 */
class ProductMedia extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.init();

    document.addEventListener('hardware-images:loaded', this.init.bind(this));
  }

  init() {
    this.selectors = {
      sliderPrimary: '[data-primary-slider]',
      sliderSecondary: '[data-secondary-slider]',
      mediaItem: '[data-media-id]',
    };

    this.selectedMediaIndex =
      Number(
        this.querySelector(this.selectors.sliderPrimary)?.querySelector(
          '[data-selected]',
        )?.dataset.index,
      ) || 0;
    this.settings = {
      elements: {
        sliderPrimary: this.querySelector(this.selectors.sliderPrimary),
        sliderPrimaryElement: this.querySelector(
          `${this.selectors.sliderPrimary} [data-slider]`,
        ),
        sliderSecondary: this.querySelector(this.selectors.sliderSecondary),
        sliderSecondaryElement: this.querySelector(
          `${this.selectors.sliderSecondary} [data-slider]`,
        ),
      },
      instances: {
        slider: null,
      },
      options: {
        sliderPrimary: {
          initialSlide: this.selectedMediaIndex,
          spaceBetween: 20,
          watchOverflow: true,
          navigation: {
            prevEl: this.querySelector(
              '[data-primary-slider] .swiper-arrow--prev',
            ),
            nextEl: this.querySelector(
              '[data-primary-slider] .swiper-arrow--next',
            ),
          },
          pagination: {
            el: '[data-primary-slider] .swiper-pagination',
            type: 'bullets',
            clickable: true,
            dynamicBullets: true,
          },
        },
        sliderSecondary: {
          spaceBetween: 20,
          watchOverflow: true,
          navigation: {
            prevEl: this.querySelector(
              '[data-secondary-slider] .swiper-arrow--prev',
            ),
            nextEl: this.querySelector(
              '[data-secondary-slider] .swiper-arrow--next',
            ),
          },
          pagination: {
            el: '[data-secondary-slider] .swiper-pagination',
            type: 'bullets',
            clickable: true,
            dynamicBullets: true,
          },
        },
      },
    };

    if (
      this.settings.elements.sliderPrimary &&
      this.settings.elements.sliderPrimaryElement
    ) {
      this.settings.instances.sliderPrimary = new Swiper(
        this.settings.elements.sliderPrimaryElement,
        this.settings.options.sliderPrimary,
      );
    }

    if (
      this.settings.elements.sliderSecondary &&
      this.settings.elements.sliderSecondaryElement
    ) {
      this.settings.instances.sliderSecondary = new Swiper(
        this.settings.elements.sliderSecondaryElement,
        this.settings.options.sliderSecondary,
      );
    }
  }

  setActiveMedia(id) {
    const mediaFound = Array.from(
      this.querySelectorAll(this.selectors.mediaItem),
    ).find((media) => Number(media.dataset.mediaId) === id);
    if (!mediaFound) return;
    this.settings.instances.sliderPrimary.slideTo(
      Number(mediaFound.dataset.index),
    );
  }
}

customElements.define('product-media', ProductMedia);
